import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Comment.css";

const API_URL = "https://app.reciteontv.com/wp-json/vvt/v1/views"; // Change this to your site

const VideoComments = ({ postId }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const res = await axios.get(`${API_URL}/${postId}`);
        if (res.data && res.data.comments) {
          setComments(res.data.comments);
        }
      } catch (err) {
        console.error("Failed to fetch comments:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchComments();
  }, [postId]);

  return (
    <div>

    <div style={{marginTop:20,marginBottom:10}}><h4>Join the discussion</h4></div>    
    <div className="comments-section">      
      {loading ? (
        <p>Loading comments...</p>
      ) : comments.length === 0 ? (
        <p>No comments yet. Be the first to comment!</p>
      ) : (
        <ul className="comment-list">
        {comments.map((comment, index) => (
          <li key={index} className="comment-item">
            <div className="comment-header">
            <span style={{fontWeight:"normal",fontSize: "16px"}}>{comment.author} </span> 
            <span style={{ paddingLeft:10,fontSize: "11px",fontWeight: "normal",letterSpacing:"0.5px",textTransform: "uppercase"}}> 
                {new Date(comment.date).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}</span>
            </div>
            
            <div className="comment-content" style={{marginTop:10,fontSize: "0.875em"}}>
              {comment.content}
            </div>
          </li>
        ))}
      </ul>
      )}
    </div>
    </div>
  );
};

export default VideoComments;
